import React from 'react';

import { useIntlDictionary } from 'hooks/useIntlDictionary';
import { M8DebitDTO } from 'services/production/types';
import { ClickControlComponent } from 'design/clickControl/clickControlComponents';
import { TextComponent } from 'design/text/textComponents';

type Props = {
  m8DebitDTO: M8DebitDTO;
  onManageBill(billId: number): void;
};

export const GiroPaymentManagerBillRow = (props: Props) => {
  const { m8DebitDTO, onManageBill } = props;

  const {
    giroPaymentManager: { summaryScreen: ownDictionary },
  } = useIntlDictionary();

  const billPrimaryAmountText = ownDictionary.clientTable.billPrimaryAmountText(
    m8DebitDTO
  );

  const billSecondaryAmountText = ownDictionary.clientTable.billSecondaryAmountText(
    m8DebitDTO
  );

  return (
    <>
      <span>
        <ClickControlComponent onClick={() => onManageBill(m8DebitDTO.id)}>
          <TextComponent color="accent">{billPrimaryAmountText}</TextComponent>
        </ClickControlComponent>{' '}
        {billSecondaryAmountText}
      </span>
      <br />
    </>
  );
};
